"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storesContext = void 0;
var react_1 = __importDefault(require("react"));
var ApiStore_1 = __importDefault(require("stores/ApiStore"));
var PrefsStore_1 = __importDefault(require("stores/PrefsStore"));
var UserStore_1 = __importDefault(require("stores/UserStore"));
var ClientStore_1 = __importDefault(require("stores/ClientStore"));
var ProjectStore_1 = __importDefault(require("stores/ProjectStore"));
var AllUserStore_1 = __importDefault(require("stores/AllUserStore"));
exports.storesContext = react_1.default.createContext({
    apiStore: ApiStore_1.default,
    userStore: UserStore_1.default,
    allUserStore: AllUserStore_1.default,
    prefsStore: PrefsStore_1.default,
    clientStore: ClientStore_1.default,
    projectStore: ProjectStore_1.default
});
